import type { DialogueKwFaqMessage } from 'components/Dialogue/types';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { BaseMsgProps } from './types';
import QuoteMessage from '../QuoteMessage';
import { useChatContext } from '../../contexts/ChatContext';
import { memo, useState } from 'react';
import styled from '@emotion/styled';
import { Button } from 'antd';
import { SyncOutlined } from '@ant-design/icons';

export const KwFaqMsg = memo((props: BaseMsgProps) => {
  const { raw, msg, conversation } = props;
  const { clickQuote } = useChatContext();
  const { title, questions } = (msg as DialogueKwFaqMessage).content;
  const { topBarInfo } = conversation;

  const [index, setIndex] = useState(0);

  const questionDisplayLength = 3;

  return (
    <MessageExtendComplex
      {...props}
      content={
        <QuoteMessage
          message={raw}
          storeName={topBarInfo?.storeName}
          wrap
          onQuoteClick={clickQuote}
        >
          <Container>
            <div>{title}</div>
            {questions.slice(index, index + questionDisplayLength).map((question) => {
              return <p>{question}</p>;
            })}
            {questions.length > questionDisplayLength && (
              <Button
                block
                type="text"
                icon={<SyncOutlined />}
                onClick={() => setIndex((index + questionDisplayLength) % questions.length)}
              >
                换一换
              </Button>
            )}
          </Container>
        </QuoteMessage>
      }
    />
  );
});

const Container = styled.div`
  width: 320px;
  padding: 12px;
  background: #fff;
  border-radius: 2px;
  > div {
    margin-bottom: 8px;
  }
  > p {
    margin-bottom: 8px;
    color: var(--ant-primary-color);
  }
`;
